import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  updateFilled() {
    this.element.dataset.filled = this.element.files.length > 0
  }
}
